/**
 * Inicialização do Sentry no PWA usuário.
 *
 * Só liga se `VITE_SENTRY_DSN` estiver setado — sem DSN, vira no-op.
 * Integramos com `vue-router` pra rastreio automático de navegação.
 */
import type { App } from 'vue';
import type { Router } from 'vue-router';
import * as Sentry from '@sentry/vue';

export function initSentry(app: App, router: Router): void {
    const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
    if (!dsn) return;

    Sentry.init({
        app,
        dsn,
        environment: (import.meta.env.MODE as string) || 'production',
        // Free tier: 5k eventos/mês. 100% dos erros, 20% das transações.
        tracesSampleRate: 0.2,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
        ],
    });
}
